import type { LoadingStatus } from 'components/users/flexlist/FlexList';
import type { UsersSummaryTotals } from 'redux/modules/users-page/users-dashboard/usersDashboard.types';
import type { StartOfWeek } from 'types/account';
import type { DateTypePeriodNames } from 'types/dates';
import type { DurationSummary } from 'types/summaries';
import type { Duration } from 'types/units';
import type { User } from 'types/user';
import type { DeepPartial } from 'types/utility';
import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('timely/usersPage/list');

export const setQuery = actionCreator<SetListQueryPayload>('SET_QUERY');
export const setFilters = actionCreator<Partial<Filter>>('SET_FILTERS');
export const clearQuery = actionCreator('CLEAR_QUERY');
export const fetchedTotals = actionCreator<UsersSummaryTotals>('FETCHED_TOTALS');
export const clearTotals = actionCreator('CLEAR_TOTALS');

export const showDetails = actionCreator<DetailsRef>('SHOW_DETAILS');
export const hideDetails = actionCreator('HIDE_DETAILS');

export const sortBy = actionCreator<{ by: string; direction: 'asc' | 'desc' }>('SORT_BY');

export interface DetailsRef {
  userId: number;
  date: string;
}
export interface TotalsByWeek {
  users: number;
  capacity: Duration;
  duration: Duration;
  billable_duration: Duration;
  non_billable_duration: Duration;
  planned_duration: Duration;
  estimated_duration: Duration;
}

export interface Totals {
  [weekKey: string]: TotalsByWeek;
}

export interface ControlState {
  detailsRef: DetailsRef | null;
  shouldReload: boolean;
}
//This should be expanded to match query filter when we need it
// undefined means no filter (show all users/teams)
export interface Filter {
  userIds?: Array<number>;
  teamIds?: Array<number>;
}

export interface Query {
  from?: string;
  to?: string;
  span?: DateTypePeriodNames | undefined;
  show?: 'active' | 'deleted';
  sort: {
    by: string;
    direction: 'asc' | 'desc';
  };
  filters: {
    userIds: Array<number>;
    teamIds: Array<number>;
  };
  // cacheBuster?: string;
}

interface SetListQueryPayload {
  startOfWeek: StartOfWeek;
  query?: DeepPartial<Query>;
}

export interface State {
  query: Query;
  filters: Filter;
  totals: Totals;
  control: ControlState;
}
interface ListUserCustomProps {
  avatar: string;
  isLoaded: boolean;
  status: LoadingStatus;
  summary: DurationSummary;
  url: string;
}

export type ListUser = Omit<User, 'avatar'> & ListUserCustomProps;

export interface ControlRange {
  date: string;
  dayInMonth: number;
  isAfterToday: boolean;
  isToday: boolean;
  isWeekend: boolean;
  monthName: string;
  weekNumber: number;
}

export interface ControlData {
  [dayKey: string]: {
    duration: number;
    total_duration: number;
    billable_duration: number;
    non_billable_duration: number;
    capacity: number;
  };
}
